import React from 'react';
import PropTypes from 'prop-types';

// FSSAI vegetarian mark (India). Regulated colours, so no fill override.
const FssaiVegetarianIcon = ({ className, width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width}
    height={height}
    viewBox="0 0 200 200"
  >
    <rect x="25" y="25" width="150" height="150" fill="none" stroke="#00a651" strokeWidth="5" />
    <circle cx="100" cy="100" r="50" fill="#00a651" />
  </svg>
);

FssaiVegetarianIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

FssaiVegetarianIcon.defaultProps = {
  height: '100%',
  width: '100%',
};

export default FssaiVegetarianIcon;
